import React from 'react';
import { motion } from 'framer-motion';
export function PrivacyPolicyPage() {
  return <main className="flex-1 bg-background" data-id="element-315">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-316">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-317">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-318">
            Privacy & Cookie Policy
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-319">
            Bluecore is committed to protecting your privacy and personal data.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white" data-id="element-320">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-12" data-id="element-322">
            <div data-id="element-323">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-324">
                Data We Collect
              </h2>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-325">
                <li data-id="element-326">
                  <strong className="text-slate-800" data-id="element-327">
                    Personal Information:
                  </strong>{' '}
                  Name, email address, and account credentials.
                </li>
                <li data-id="element-328">
                  <strong className="text-slate-800" data-id="element-329">Usage Data:</strong>{' '}
                  Reading history, access logs, and platform preferences.
                </li>
                <li data-id="element-330">
                  <strong className="text-slate-800" data-id="element-331">
                    Payment Information:
                  </strong>{' '}
                  Processed securely via Stripe. We do not store your full
                  credit card details on our servers.
                </li>
              </ul>
            </div>

            <div data-id="element-332">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-333">
                How We Use Your Data
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-334">
                We use your information for the following purposes:
              </p>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-335">
                <li data-id="element-336">To manage your account and authentication.</li>
                <li data-id="element-337">
                  To provide access to our ebook library and track your reading
                  progress.
                </li>
                <li data-id="element-338">
                  To send important service updates and support communications.
                </li>
                <li data-id="element-339">
                  To improve our service, fix technical issues, and enhance user
                  experience.
                </li>
              </ul>
            </div>

            <div data-id="element-340">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-341">
                Cookies
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-342">
                We use cookies to enhance the performance of our website and
                provide analytics.
              </p>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-343">
                <li data-id="element-344">
                  <strong className="text-slate-800" data-id="element-345">Essential Cookies:</strong>{' '}
                  Required for the site to function properly (e.g., keeping you
                  logged in).
                </li>
                <li data-id="element-346">
                  <strong className="text-slate-800" data-id="element-347">Analytics Cookies:</strong>{' '}
                  Help us understand how users interact with our service so we
                  can improve it. You can disable these in your browser
                  settings.
                </li>
              </ul>
            </div>

            <div data-id="element-348">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-349">
                Your GDPR Rights
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-350">
                Under GDPR, you have the following rights regarding your
                personal data:
              </p>
              <ul className="space-y-3 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-351">
                <li data-id="element-352">The right to access your personal data.</li>
                <li data-id="element-353">The right to correction of inaccurate data.</li>
                <li data-id="element-354">The right to deletion ("right to be forgotten").</li>
                <li data-id="element-355">The right to object to processing.</li>
                <li data-id="element-356">The right to data portability.</li>
              </ul>
              <p className="text-lg text-slate-600 leading-relaxed mt-4" data-id="element-357">
                To exercise any of these rights, please email us at{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-358">
                  manishhoran123@gmail.com
                </a>
                .
              </p>
            </div>

            <div data-id="element-359">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-360">
                Data Security
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-361">
                We use bank-grade encryption, secure servers, and regular
                security audits to protect your data. Payment processing is
                handled by Stripe, a certified PCI Service Provider Level 1.
              </p>
            </div>

            <div data-id="element-362">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-363">
                Data Retention
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-364">
                We retain your personal data for the duration of your
                subscription and for up to 6 years thereafter for legal and
                accounting compliance purposes.
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-365">
              <h2 className="text-xl font-bold text-slate-dark mb-2" data-id="element-366">
                Contact Us
              </h2>
              <p className="text-slate-600" data-id="element-367">
                If you have any questions about our privacy practices, please
                contact our Data Protection Officer at{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-368">
                  manishhoran123@gmail.com
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}